var map = {
	"./Solar-Space_symbol_0.png": 88834,
	"./Solar-Space_symbol_1.png": 9963,
	"./Solar-Space_symbol_2.png": 38672,
	"./Solar-Space_symbol_3.png": 44921,
	"./Solar-Space_symbol_4.png": 95526,
	"./Solar-Space_symbol_5.png": 34543,
	"./Solar-Space_symbol_6.png": 60052,
	"./Solar-Space_symbol_7.png": 76733,
	"./Solar-Space_symbol_8.png": 138,
	"./Solar-Space_symbol_9.png": 55347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93707;